import { combineReducers } from "redux";
import app, { AppStateT } from "./services/app/reducer";
import auth, { AuthStateT } from "./services/auth/reducer";
import user, { UserStateT } from "./services/user/reducer";
import orgs, { OrgStateT } from "./services/organizations/reducer";
import dealerGroups, { OrgStateT as DGroupOrgStateT } from "./services/dealergroups/reducer";
import notifications, { NotificationStateT } from "./services/notifications/reducer";
import subscription, { SubscriptionStateT } from "./services/subscription/reducer";

// Root state of the store
export type RootState = {
    app: AppStateT;
    auth: AuthStateT;
    user: UserStateT;
    orgs: OrgStateT;
    notifications: NotificationStateT;
    subscription: SubscriptionStateT;
    dealerGroups: DGroupOrgStateT;
};

// Root reducer configuration
const rootReducer = combineReducers<RootState>({
    app,
    auth,
    user,
    orgs,
    notifications,
    subscription,
    dealerGroups,
});

export default rootReducer;
